import { useQuery } from '@apollo/client';
import { ContentBlock, Loader } from 'braid-design-system';
import React from 'react';

import type { Country } from '../entities/Country';
import { FEATURE_TOGGLE } from '../graphql';

const FeaturesContext = React.createContext<FeaturesContextValue>({
  features: [],
});

interface FeaturesContextValue {
  features: string[];
}

export const useFeatures = () =>
  React.useContext<FeaturesContextValue>(FeaturesContext);

interface FeatureToggleData {
  getPaymentConfig: {
    features: string[];
  };
}

interface FeatureToggleVariables {
  advertiserId?: string;
  country: string;
  site: string;
}

export const FeaturesProvider: React.FC<{
  children: React.ReactNode;
  country: Country;
}> = ({ children, country }) => {
  const site = 'seekjobs';

  // by default, all toggled features are disabled
  const [features, setFeatures] = React.useState<string[]>(() => []);

  const { loading } = useQuery<FeatureToggleData, FeatureToggleVariables>(
    FEATURE_TOGGLE,
    {
      variables: { country, site },
      onCompleted: (data) => {
        const f = data.getPaymentConfig.features;
        setFeatures(f || []);
      },
      onError: () => {},
    },
  );

  return (
    <FeaturesContext.Provider
      value={{
        features,
      }}
    >
      {loading ? (
        <ContentBlock width="large">
          <Loader />
        </ContentBlock>
      ) : (
        children
      )}
    </FeaturesContext.Provider>
  );
};
